import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldIcon } from 'lucide-react';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';

/**
 * Shown when a signed-in identity reaches a console it holds no role for.
 * Signing in proves who you are; it does not decide what you may do.
 */
export function NoAccess() {
  const {
    identity
  } = useAuth();
  const {
    workspaces,
    memberships
  } = useWorkspace();
  const [params] = useSearchParams();
  const need = params.get('need');
  const internal = need === 'internal';
  return <AuthLayout title="You are signed in, but not authorised for this" intro={internal ? 'This is Campuzon internal administration. It is not a workspace and not an account role — it is provisioned separately, so no membership can reach it.' : 'Campuzon separates identity from permission. Your account is valid — it just is not a member of anything that opens this.'} data-id="element-8205" data-mp="1o302tfzcxkem">
      <p className="flex items-start gap-2 text-body text-ink" data-id="element-8206" data-mp="62dgbrnxjvcw">
        <ShieldIcon aria-hidden className="mt-0.5 h-5 w-5 shrink-0 text-ink-muted" data-id="element-8207" data-mp="3nin1hjaqqk0e" />
        <span data-id="element-8208" data-mp="3si8361hap6gt">
          {identity ? `@${identity.username} ` : 'This account '}
          holds {memberships.length} membership{memberships.length === 1 ? '' : 's'}, opening{' '}
          {workspaces.length === 0 ? 'no workspace' : workspaces.map(space => `${space.label} (${space.ownerLabel})`).join(', ')}
          . Access follows membership, and the services enforce it — not this screen.
        </span>
      </p>
      {need && !internal && <p className="mt-3 cz-num text-caption text-ink-subtle" data-id="element-8209" data-mp="12tfqanz14epn">Required: {need}</p>}
      <div className="mt-5 flex flex-wrap gap-3" data-id="element-8210" data-mp="12rmg4yp7jccw">
        <Link to="/" data-id="element-8211" data-mp="17r7jdlbeu6vf">
          <Button variant="primary" data-id="element-8212" data-mp="17rr0x0x5et8x">Back to Campuzon</Button>
        </Link>
        <Link to="/network" data-id="element-8213" data-mp="16c4tko4zhzgf">
          <Button variant="secondary" data-id="element-8214" data-mp="169a7yta8i8lf">Apply as a representative</Button>
        </Link>
      </div>
    </AuthLayout>;
}